export default "__VITE_ASSET__DndpDSTF__"